'use client';

import React from 'react';
import PosterCard from './PosterCard';
import MediaGridSkeleton from './MediaGridSkeleton';
import type { MediaItem } from '@/lib/types';
import { Film } from 'lucide-react';

interface Props {
  items: MediaItem[];
  selectedIds: Set<string>;
  onToggleSelect: (id: string) => void;
  isLoading: boolean;
}

export default function MediaGrid({ items, selectedIds, onToggleSelect, isLoading }: Props) {
  if (isLoading) return <MediaGridSkeleton />;

  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <div className="w-16 h-16 rounded-2xl bg-muted flex items-center justify-center mb-4">
          <Film size={28} className="text-muted-foreground" />
        </div>
        <h3 className="text-base font-semibold text-foreground mb-1">No media found</h3>
        <p className="text-sm text-muted-foreground max-w-xs">
          No items match your current filters. Try adjusting the search or status filter.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-4 pt-2">
      {items.map((item) => (
        <PosterCard
          key={item.id}
          item={item}
          isSelected={selectedIds.has(item.id)}
          onToggle={() => onToggleSelect(item.id)}
        />
      ))}
    </div>
  );
}